import { useState } from 'react'
import DOMPurify from 'dompurify';
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import Stepper from "react-stepper-horizontal";
import { Button, Modal } from 'react-bootstrap';
import MapRoleAndGroup from './MapRoleAndGroup';
import useAxios from '../../hooks/useAxios'
const CreateGroup = ({ show,hide,loadGroups }) => {
    const [name, setName] = useState("");
    const [groupId, setGroupId] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));
    const axiosInstance = useAxios()
    const handleSubmit = (e) => {
      e.preventDefault();
      const data = {
        name,
      };
      axiosInstance({
        url:'/users/groups',
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.access_token}`,
        },
        data: data,
      })
        .then((res) => {
          if (res.status >= 200 && res.status <= 300) {
            setActiveStep(1);
            setGroupId(res.data.id);
            toastSuccess("Group created successfully");
          } else {
            toastError("Could not create user group");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={hide}>
          <h5>{activeStep === 0 ? "Creating Group" : "Map group and role"}</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <Stepper
            steps={[
              { title: "Create Group" },
              { title: "Map Role to a group" },
            ]}
            activeStep={activeStep}
          />
          {activeStep === 0 && (
            <form onSubmit={handleSubmit} className='mt-3'>
              <label className='ml-2'>Group name</label>
              <input
                className='form-control input-select'
                type='text'
                name='name'
                placeholder='Enter group name'
                onChange={(e) => setName(DOMPurify.sanitize(e.target.value))}
                required
              />
              <label className='mt-2 ml-2'>Descritpiton</label>
              <textarea
                placeholder='Description'
                className='form-control input-select mt-2'
              />
              <div className='d-flex justify-content-center'>
                <Button className='custom-btn-color' type='submit'>
                  Next
                </Button>
              </div>
            </form>
          )}
          {activeStep === 1 && (
            <MapRoleAndGroup
              groupId={groupId}
              hide={hide}
              loadGroups={loadGroups}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CreateGroup